function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * 会議素材（グループ）アイテム　モデル
 */
var UploadGroupMaterialsItemInstanceModel =
/**
 * コンストラクタ
 *
 */
function UploadGroupMaterialsItemInstanceModel() {
  _classCallCheck(this, UploadGroupMaterialsItemInstanceModel);

  this.SessionId = -1;
  this.MaterialFileName = "";
  this.ItemId = -1;
  this.ItemName = null;
  this.LastModified = null;
  this.Included = false;
};

export { UploadGroupMaterialsItemInstanceModel as default };